export const LastUpdated = '6 Mai 2026';
